import { gql } from "@apollo/client";

export const ADD_NEWSLETTER_MAILING_LIST_QUERY = gql`
  mutation AddNewsLetterMailingList(
    $email: String!
    $subscribe_status: SubscribeStatus!
  ) {
    addNewsLetterMailingList(
      newsLetterMailingListVM: {
        email: $email
        subscribe_status: $subscribe_status
      }
    ) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const ADD_CONTACT_US_INFO_QUERY=gql`
mutation($request : ContactUsVMInput!) {
  addContactUsInfo(
    contactUsVM: $request 
  ) {
    responseData {
      acknowledgement
      created_on
      email
      id
      mobile_number
      name
      organization
      remarks
      subject
    }
    successTypeCode
    messageDescription
  }
}
`;

export const CONFIG_VALUE_QUERY = gql`
  query ConfigValue($config_key: String!) {
    configValue(config_key: $config_key) {
      messageDescription
      responseData
      successTypeCode
    }
  }
`;
